<div class="products">
  
  <cm-topbar title="Ad tags" *ngIf="!selectedWidget">
    <div class="col-12 col-sm col-md-auto top-bar-middle">
      <nav mat-tab-nav-bar class="mat-tab-nav-bar--platforms">
        <a mat-tab-link [active]="selectedPlatform === platform.key" *ngFor="let platform of availablePlatforms"
           (click)="onSelectedPlatform(platform)">
          <i class="far fa-desktop" *ngIf="platform.key === 'DESKTOP'"></i>
          <i class="far fa-mobile" *ngIf="platform.key === 'MW'"></i>
          <span>{{platform.label}}</span>
        </a>
      </nav>
      
      <!-- TODO@toni - Nakon sto prebacimo "desk"/"mob"/"responsive" i sidemenu ovo ostaje tu na vrhu -->
    
    </div>
  </cm-topbar>
  
  <div class="d-flex justify-content-center mt-5" *ngIf="showLoader">
    <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="'50'"></mat-spinner>
  </div>
  
  <div *ngIf="!selectedWidget && isDataAvailable">
    <div class="main-content main-content--has-tabs">
      
      <div class="popular-units">
        <button mat-button color="primary"
                ng-class="{'active': !vm.mostPopularSelected}"
                *ngIf="mostPopularSelected"
                (click)="showAllProducts()"
                class="iconed">
          <i class="fas fa-star" aria-hidden="true"></i>
          <span>Most popular</span>
        </button>
        <button mat-button color="primary"
                ng-class="{'active': vm.mostPopularSelected}"
                *ngIf="!mostPopularSelected"
                (click)="showMostPopular()"
                class="iconed">
          <i class="far fa-star white" aria-hidden="true"></i>
          <span>Most popular</span>
        </button>
      </div>
      
      <div class="container-fluid">
        <div class="row">
          
          <!--SIZES-->
          <nav mat-tab-nav-bar class="mat-center-links w-100">
            <a mat-tab-link
               *ngFor="let size of availableSizes"
               [active]="selectedSize === size.key"
               (click)="onSelectedSize(size)"
               style="min-width: 0;">
              {{size.label}}
            </a>
          </nav>
          
          <!--WIDGETS-->
          <div class="col-12">
            <ul class="product-widget-list d-flex flex-wrap justify-content-center">
              <li *ngFor="let widget of availableWidgets"
                  class="product-widget-box d-flex flex-column align-items-center"
                  [class.widget-owned]="widget._owned"
                  (mouseleave)="widget._liveSitesOpened = false">
                <div class="most-popular white" *ngIf="widget.mostPopular" title="Most popular!">
                  <i class="fas fa-star" aria-hidden="true"></i>
                </div>
                <div class="widget-box-header">
                  <h4>{{widget.displayName || widget.content}}</h4>
                </div>
                <div class="widget-box-demo">
                  <img [src]="widget.demoImageUrl"
                       [attr.width]="widget.width ? widget.width :''"
                       [attr.height]="widget.height ? widget.height :''"
                       (click)="openPreviewModal(widget)"
                       (load)="widget._imageLoaded = true"
                  >
                  <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"
                               *ngIf="!widget._imageLoaded"></mat-spinner>
                </div>
                <div class="widget-box-content">
                  <div class="widget-box-content-header" *ngIf="widget._owned">
                    <i class="fas fa-check"></i>
                    <p>You are using this unit already, but you can add it to more sites.</p>
                  </div>
                  <div class="widget-box-content-header" *ngIf="!widget._owned">
                    <i class="far fa-file-alt"></i>
                    <p>You are not using this unit. Add this unit to you sites now by requesting it below.</p>
                  </div>
                  <div class="widget-box-content-body d-flex flex-column">
                    <button mat-raised-button color="white" class="button large mb-3" (click)="selectWidget(widget)">
                      <span *ngIf="widget._owned">Add to more sites</span>
                      <span *ngIf="!widget._owned">Request this unit</span>
                    </button>
                    <button mat-raised-button color="white" class="button large" (click)="openPreviewModal(widget)">Unit
                                                                                                                    preview
                    </button>
                    <!--<button mat-raised-button color="white" class="button large mt-3" *ngIf="widget.demoSiteUrl"-->
                    <!--(click)="openDemoSite(widget)">Demo site-->
                    <!--</button>-->
                  </div>
                  <div class="widget-box-content-footer">
                    <button mat-button class="button large mt-3" *ngIf="widget._owned"
                            (click)="widget._liveSitesOpened = !widget._liveSitesOpened"
                            [class.opened]="widget._liveSitesOpened">
                      <span *ngIf="!widget._liveSitesOpened">Live sites list</span>
                      <i class="fas fa-times" *ngIf="widget._liveSitesOpened"></i>
                    </button>
                    <div class="publisher-owned-list-wrapper" [class.opened]="widget._liveSitesOpened">
                      <ul class="publisher-owned-list" *ngIf="widget._owned">
                        <li *ngFor="let domain of widget.publisherDomains">{{domain.url}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          
          </div>
        
        
        </div>
      </div>
    </div>
  </div>
  
  <!--SUMMARY-->
  <cm-publisher-request-summary
    *ngIf="selectedWidget"
    [widgetType]="selectedWidget"
    (requestCanceled)="selectedWidget = null"
    [platform]="selectedPlatform">
  </cm-publisher-request-summary>
</div>
